import { UserAttributeKind } from '@hotjar/global-filters/src/domains/user-attributes/model/UserAttribute';
import { QueryKeyEnum } from '@hotjar/global-filters/src/domains/global-filters/model/QueryFormat';

import type { UserAttributeType } from '@hotjar/global-filters';
import type { UserAttributeClause } from '@hotjar/feedback/domain/Surveys/Responses/Filters/Clause';
import { mapStringUserAttribute } from './StringUserAttribute';
import { mapBooleanUserAttribute } from './BooleanUserAttribute';
import { mapNumberUserAttribute } from './NumberUserAttribute';
import { mapDateUserAttribute } from './DateUserAttribute';

export enum UserAttributeQueryKind {
  STR = 'str',
  BOOL = 'bool',
  NUMBER = 'number',
  UNKNOWN = 'unknown',
  DATE_RELATIVE = 'date_relative',
  DATE_ABSOLUTE = 'date_absolute',
}

export enum UserAttributesFilter {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  CONTAINS = 'CONTAINS',
  ENDS_WITH = 'ENDS_WITH',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  IS_UNKNOWN = 'IS_UNKNOWN',
  HAS_ANY_VALUE = 'HAS_ANY_VALUE',
}

export type UserAttributeClauseNameless = Omit<UserAttributeClause, 'name'>;

// eslint-disable-next-line camelcase
export type UserAttributeWithKindType = `${QueryKeyEnum.user_attributes}.${UserAttributeQueryKind}`;

export const mapUserAttributeFilter = (filter: UserAttributeType): UserAttributeClause => {
  const name = filter.name || '';

  switch (filter.kind) {
    case UserAttributeKind.String:
    case UserAttributeKind.Email:
      return { ...mapStringUserAttribute(filter.value), name };
    case UserAttributeKind.Boolean:
      return { ...mapBooleanUserAttribute(filter.value), name };
    case UserAttributeKind.Number:
      return { ...mapNumberUserAttribute(filter.value), name };
    case UserAttributeKind.Date:
      return { ...mapDateUserAttribute(filter.value), name };
    default:
      // We should not arrive here as we filter out unknown user attributes
      // But to avoid breaking the flow, we return a default value
      return {
        name: 'unknown',
        type: `${QueryKeyEnum.user_attributes}.${UserAttributeQueryKind.UNKNOWN}`,
      };
  }
};
